<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="false"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
      <el-form-item label="手机号码">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.phone"
          placeholder="请输入手机号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in tranTypes"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatId"
        label="机构简称"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        min-width="280"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="name"
        label="会员姓名"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="电话号码"
        min-width="130"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="levelName"
        label="购买等级名称"
        :formatter="formatterTableData"
        min-width="150"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="needAmt"
        label="需付金额"
        :formatter="formatterTableNumber"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="imgUrl" label="充值凭证" min-width="100">
        <template slot-scope="scope">
          <div
            style="cursor: pointer"
            @click="look(scope)"
            class="iconUrl"
            :style="
              'background:url(' +
              scope.row.payCertUrl +
              ') center/cover no-repeat '
            "
          ></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="modifier"
        label="操作人"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        :formatter="formatterTableStatus"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="160"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" min-width="160">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">
            <el-button type="text" @click="openAddDialog(1, scope.row)"
              >审核</el-button
            >
          </div>
          <div v-else>已操作!</div>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '审核' : '充值'"
      :model="dialogModel"
      :submitData="dialogData"
      labelWidth="120px"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
    >
      <el-form-item label="审核方式" prop="result">
        <el-radio v-model="dialogModel.result" label="1">通过</el-radio>
        <el-radio v-model="dialogModel.result" label="2">驳回</el-radio>
      </el-form-item>
      <el-form-item
        label="驳回原因"
        prop="remark"
        v-if="dialogModel.result == 2"
      >
        <el-input
          type="textarea"
          placeholder="请输入"
          v-model="dialogModel.remark"
          maxlength="300"
          rows="5"
          show-word-limit
        >
        </el-input>
      </el-form-item>
    </form-dialog>
    <show-info-dialog
      title="充值凭证"
      :show="true"
      ref="showInfoDialog"
      class="showInfoDialog"
    >
      <div v-if="czimgUrl == '' || czimgUrl == null">
        <div
          style="
            display: flex;
            justify-content: center;
            color: red;
            font-size: 20px;
          "
        >
          暂未提供充值凭证,还请核对后在审核!!!
        </div>
      </div>
      <div v-else>
        <img
          class="showImage flex-row absolute-center"
          :src="czimgUrl"
          alt=""
          srcset=""
        />
      </div>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import FormDialog from "../../dialog/FormDialog";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";

import MallService from "service/MallService";
import TimeRange from "service/constant/TimeRange";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "offlinepaymentreview",
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
    FormDialog,
    ShowInfoDialog,
  },
  data() {
    return {
      czimgUrl: "",
      itemId: "",
      type: "",
      formModel: {
        tatSimpleId: "",
        phone: "",
        status: "",
      },
      dialogModel: {
        result: "",
        remark: "",
      },
      tableData: [],
      submitService: MallService.offlinepaymentreviewList,
      time: "",
      page: {},
      tranTypes: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "0",
          value: "待审核",
        },
        {
          id: "1",
          value: "通过",
        },
        {
          id: "2",
          value: "驳回",
        },
      ],
      dialogRules: {
        result: [
          {
            required: true,
            message: "请选择审核方式",
          },
        ],
      },
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  computed: {
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }
      this.params = {
        simpleTatId: this.formModel.tatSimpleId,
        status: this.formModel.status,
        phone: this.formModel.phone.trim(),
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.time.length) {
        this.params.startTime = this.time[0];
        this.params.endTime = this.time[1];
      }

      return this.params;
    },
    dialogData() {
      const params = {};
      if (this.itemId) {
        params.result = this.dialogModel.result;
        params.remark = this.dialogModel.remark;
        params.orderId = this.itemId;
        params.modifierName = this.userInfo.realName;
      }
      return params;
    },
    dialogService() {
      return MallService.offlinepaymentreviewToExamine;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  mounted() {
    this.load();
  },
  watch: {
    "dialogModel.result"(val, oldval) {
      if (val == 1) {
        this.dialogModel.remark = "";
      }
    },
  },
  methods: {
    load() {
      this.formModel = {
        tatSimpleId: "",
        phone: "",
        status: "",
      };

      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    openAddDialog(type, item) {
      this.type = type;
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
      }
      this.$refs.formDialog.open();
      this.$nextTick(() => {
        this.$refs.formDialog.clearValidate();
      });
    },
    look(scope) {
      this.czimgUrl = scope.row.payCertUrl;
      this.$refs.showInfoDialog.open();
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    dialogClose() {
      this.dialogModel = {
        result: "",
        remark: "",
      };
      this.type = "";
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    formatterTableStatus(row, column, cellValue, index) {
      let value = "--";
      this.tranTypes.forEach((item) => {
        if (item.id == cellValue) {
          value = item.value;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}

.showImage {
  max-width: 100%;
  min-width: 738px;
  min-height: 500px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/OfflinePaymentReview.vue